import { cva } from 'class-variance-authority';

import { getCsdColorClasses } from '../../../util';

export const comparisonSeverityBadgeVariants = cva(
  'inline-flex shrink-0 rounded-lg border px-3 py-1 text-sm font-semibold',
  {
    defaultVariants: {
      level: 'default',
    },
    variants: {
      level: {
        critical: getCsdColorClasses(5),
        default: 'border-neutral-200 text-neutral-200',
        informational: getCsdColorClasses(1),
        minor: getCsdColorClasses(2),
        moderate: getCsdColorClasses(3),
        urgent: getCsdColorClasses(4),
      },
    },
  },
);
